import { css } from "lit"

export const layoutStyles = css`
  /* Layout sections */
  .container {
    max-width: 1024px;
    margin: 0 auto;
    padding: 0 1.25rem;
  }

  .container-sm {
    max-width: 640px;
  }

  /* Divider */
  .divider {
    margin: 2rem auto;
    padding: 0 1.25rem;
  }

  .divider-line {
    border-bottom: 1px solid #e5e7eb;
  }
`